/* eslint-disable sort-exports/sort-exports */
/* eslint-disable @typescript-eslint/consistent-generic-constructors */
/* eslint-disable jsdoc/require-jsdoc */
export class TimestampManager {
  #timestampMap: Map<
    string,
    {
      trackTimestamp: number;
      timestamp: number;
    }
  > = new Map();

  /**
   * Returns the timestamp for the specified track.
   *
   * @param _trackId - The track id.
   * @returns The timestamp for the specified track.
   */
  public getLastTimestampForAgent(trackId: string):
    | {
        trackTimestamp: number;
        timestamp: number;
      }
    | undefined {
    return this.#timestampMap.get(trackId);
  }

  public getTimestampOffsetForAgentTrack(trackId: string): number | undefined {
    const timestamp = this.getLastTimestampForAgent(trackId);

    if (!timestamp) {
      return undefined;
    }

    const offset = timestamp.timestamp - timestamp.trackTimestamp;

    return offset;
  }

  public setTimestampForAgent(
    _agentId: string,
    timestamp: { trackId: string; trackTimestamp: number; timestamp: number }
  ): void {
    this.#timestampMap.set(timestamp.trackId, timestamp);
  }
}

export const SharedTimestampManager = new TimestampManager();
